const messages = {
    title: "Radovi na održavanju",
    description: "Trenutno se provode potrebni radovi na održavanju poslužitelja." +
        "<br/><br/>Kao rezultat, pristup <b>BRIDGESTONE <span class=\"text-danger\">PLUS</span></b> " +
        "vam trenutno nije dostupan.<br/><br/>Zahvaljujemo na strpljenju i razumijevanju." +
        "<br/><br/> Vaš Bridgestone tim"
}
export default {
    messages
}
